import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=653f3fb8&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653f3fb8')) {
      api.createRecord('653f3fb8', component.options)
    } else {
      api.reload('653f3fb8', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=653f3fb8&", function () {
      api.rerender('653f3fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Spinner.vue"
export default component.exports